import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingService } from 'src/app/_service/setting.service';
@Component({
  selector: 'app-app-wallet-setting',
  templateUrl: './app-wallet-setting.component.html',
  styleUrls: ['./app-wallet-setting.component.css']
})
export class AppWalletSettingComponent implements OnInit {
  settingForm: FormGroup;
  commonData: any = []; submitted = false; loading: boolean = false;
  constructor(private formBuilder: FormBuilder, private sharedapi: SharedService, public settingapi: SettingService) {
    this.settingForm = this.formBuilder.group({
      'key_text1': [null, Validators.required],
      'key_value1': [null],
      'key_text2': [null, Validators.required],
      'key_value2': [null],
    });
  }

  ngOnInit(): void {
    this.getCommonSettingData();

  }
  get f() { return this.settingForm.controls; }

  async updateSetting() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.settingForm.invalid) {
      this.loading = false;
      return;
    }

    await this.settingapi.updateWalletData(this.settingForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getCommonSettingData() {
    await this.settingapi.getcommon_setting_Data().subscribe((data: any) => {
      if (data.status) {
        this.commonData = data.walletdata;
        this.settingForm.patchValue({
          'key_text1': data.walletdata[0].key_text.replace('_', ' ').replace('_', ' ').toUpperCase(),
          'key_value1': data.walletdata[0].key_value,
          'key_text2': data.walletdata[1].key_text.replace('_', ' ').replace('_', ' ').toUpperCase(),
          'key_value2': data.walletdata[1].key_value
        });
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

}
